import { render, staticRenderFns } from "./TiaoShiKanban.vue?vue&type=template&id=6c1a75c5&"
import script from "./TiaoShiKanban.vue?vue&type=script&lang=js&"
export * from "./TiaoShiKanban.vue?vue&type=script&lang=js&"
import style0 from "./TiaoShiKanban.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports